export default __webpack_public_path__ + "static/media/MSSolution-business.e730d285.svg";